import { Component, inject } from '@angular/core';
import { SiaI18nService } from '../services/i18n.service';

@Component({
  selector: 'dialog-overview-example-dialog',
  template: ``,
  standalone: true,
})
export class BaseDialogComponent {
  protected i18nService = inject(SiaI18nService);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}
  translate(txt: string) {
    if (txt) {
      return this.i18nService.translate(txt);
    }
    return '';
  }
}
